import { Effect, Fiber } from 'effect'
import { useEffect, useState } from 'react'

import { useAgentApi } from '../gateway/agentApi'
import { type AgentStatus, fetchAgentStatus } from '../gateway/agentStatus'

/**
 * 組織と利用者でエージェント機能を使えるかを、描いたときに1回読んで返す。
 * ウィジェットはページの差し替えの外に描かれ、ページを移っても作り直されないので、ページを移るたびには読まない
 */
export const useAgentStatus = (organizationId: string): AgentStatus => {
  const api = useAgentApi(organizationId)
  const [status, setStatus] = useState<AgentStatus>('loading')

  useEffect(() => {
    const fiber = Effect.runFork(
      fetchAgentStatus(api).pipe(
        Effect.tap((fetched) =>
          Effect.sync(() => {
            setStatus(fetched)
          }),
        ),
      ),
    )
    // 外したときは要求を止め、古い結果で上書きしない
    return (): void => {
      Effect.runFork(Fiber.interrupt(fiber))
    }
  }, [api])

  return status
}
